export { DMS_MODULE } from '../constants';
export const NAME = 'ProdejNovychVozu';
export const CRUMB_LABEL_KEY = 'NV_Prodeje';

export enum PnvPznType {
	MONTAZ_DV_INKLUZIVNI = 1,
	MONTAZ_DV_INTERNI = 2,
	MONTAZ_DV_ZAKAZNIK = 3,
}

export enum Pnv2PznType {
	BEZNY_PNV = 1,
	FINANCNI_LEASING_NV = 2,
	LOCATING_NV = 3,
	INTERNI_PNV = 4,
	PREDVADECI_NV = 5,
	PROTIUCET = 6,
	VELKOODBERATEL = 7,
	SLUZEBNI_VUZ = 8,
	PRODEJ_NA_UVER = 9,
	OPERATIV_LEASING_NV = 11,
	SKODA_BEZ_STAROSTI = 12,
	FLEETOVE_CENTRUM = 13,
}
